import type { Directory } from '@witmetrics/utils';
import { formatFileSize } from '@witmetrics/utils/strings';
import { countFiles } from '../../utils';

export const classes = {
  node: 'flex flex-col',
  row: 'group flex items-center gap-2 rounded-lg py-1 pl-1 pr-2 hover:bg-grey-2 dark:hover:bg-white/[0.06]',
  rowButton:
    'flex min-w-0 grow cursor-pointer items-center gap-2 text-left outline-none',
  iconSlot: 'size-8 shrink-0 place-center',
  icon: 'size-5 text-grey-6 dark:text-mauve-3',
  img: 'size-8 shrink-0 rounded-md bg-white dark:bg-[#332e43] object-contain',
  details: 'flex min-w-0 flex-col',
  name: 'truncate text-sm text-grey-8 dark:text-mauve-1',
  subtitle: 'text-xs font-light text-grey-6 dark:text-mauve-3',
  removeIcon:
    'shrink-0 cursor-pointer text-xl text-grey-6 dark:text-mauve-3 opacity-0 transition-opacity hover:text-grey-8 dark:hover:text-mauve-1 group-hover:opacity-100',
  children: 'flex flex-col pl-6',
};

/** A file shows its human-readable size; a folder shows its file count. */
export function getNodeSubtitle(contents: Directory | File): string {
  if (contents instanceof File) return formatFileSize(contents.size);
  const count = countFiles(contents);
  return `${count} file${count === 1 ? '' : 's'}`;
}
